<!--弹出框形式账单列表-->
<template>

    <div>
        <van-nav-bar :title="title" v-if="titleShow">
        </van-nav-bar>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="哥哥找过了,没有更多了,爱宝爱宝"
                    loading-text="宝不着急,哥哥正在找,嗷呜~"
                    :error.sync="error"
                    error-text="请求失败，点击重新加载"
                    @load="onLoad"
            >
                <van-swipe-cell v-for="item in list" :key="item.finId">

                    <van-cell >

                        <!-- 使用 title 插槽来自定义标题 -->
                        <template slot="title">
                            <van-row type="flex" justify="space-between">
                                <van-col span="11" >
                                    <span style="font-size: 20px">{{splitDate(item.inputDate)}}</span>
                                    <span> {{splitTime(item.inputDate)}}</span>
                                </van-col>
                                <van-col span="6">

                                    <van-tag  plain  :type="getFinType(item.finType)" style="float: right;">{{item.finTypeName}}</van-tag>
                                </van-col>
                                <van-col span="7">
                                    <span style="font-size: 20px">￥{{item.amount}}</span>
                                </van-col>
                            </van-row>
                            <van-row type="flex" >
                                <van-col span="4" >{{item.belongName}}</van-col>
                                <van-col span="6" offset="10"><span style="float:left">{{item.sortName}}</span></van-col>
                                <van-col span="6"><span style="color:#969799;font-size: 12px">{{item.sortDetailName}}</span></van-col>
                            </van-row>

                            <van-row type="flex" v-if="item.finType == 12101">
                                <van-col span="24" >
                                    <van-tag  plain round  type="warning" style="margin-top:5px">{{item.payerName}}付款</van-tag>
                                    <van-tag  plain round  type="warning" style="margin-top:5px" v-if="item.usePM">零花钱结算</van-tag>
                                    <van-tag  plain round  type="warning" style="margin-top:5px" v-if="item.rollOverAccounts">轧账余额{{item.rollOverAccounts}}</van-tag>
                                </van-col>
                            </van-row>
                            <van-row type="flex" justify="space-between">
                                <van-col span="24" >
                                    <span style="float: left;color:#969799;font-size: 12px">{{item.remark}}</span>
                                </van-col>

                            </van-row>
                        </template>

                    </van-cell>
                    <template slot="right">
                        <van-button square plain type="info" text="修改" class="upd-button" @click="alterFin(item.finId)"/>
                        <van-button square plain type="danger" text="删除" class="upd-button" @click="removeFin(item.finId)"/>
                    </template>
                </van-swipe-cell>
            </van-list>

        </van-pull-refresh>

    </div>

</template>

<script>
    import * as MyApi from '../../api/URLApiAddr.js'
    export default {
        name: 'PopupFinList',
        props:{
            qryData:{
                type: Object
            },
            refreshIndex:{
                type: Number
            },
            titleIsShow:{
                default: true,
                type: Boolean
            }
        },
        data() {
            return {
                title: '账单详情',
                titleShow: this.titleIsShow,
                list: [],
                error: false,
                loading: false,
                finished: false,
                refreshing: false,
                tagType: "danger",
                pageInfo:{
                    day: this.qryData['day'],
                    sortDetail: this.qryData['sortDetail'],
                    finType: this.qryData['finType'],
                    month: this.qryData['month'],
                    year: this.qryData['year'],
                    billTypes: this.qryData['billTypes'],
                    billStatus: this.qryData['billStatus'],
                    current:1,
                    size:50,
                    total:-1,
                    belongs: [],
                    startDate: '',
                    endDate: '',
                    sorts: [],
                    details: [],
                    payers: [],
                    finTypes: []
                },
                popupShow: false


            }
        },
        watch:{
            // 监测路由变化,只要变化了就调用获取路由参数方法将数据存储本组件即可
            // qryData(){
            //     debugger
            //     this.onRefresh()
            // },
            refreshIndex(){
                this.onRefresh()
            }
        },
        // created() {\

        //     this.getParams()
        //
        // },
        // mounted(){//侦听refreshIndex,所以不需要加载以后刷新数据
        //     this.onRefresh()
        // },
        methods: {
            onLoad() {

                // if(this.pageInfo.month == undefined || this.pageInfo.month == ''){
                //     this.$toast.fail("月份不能为空")
                //     this.finished = true
                //     return false
                // }


                this.pageInfo.day = this.qryData['day']
                this.pageInfo.sortDetail = this.qryData['sortDetail']
                this.pageInfo.finType = this.qryData['finType']
                this.pageInfo.month = this.qryData['month']
                this.pageInfo.year = this.qryData['year']
                this.pageInfo.belongs = this.qryData['belongs']
                this.pageInfo.sorts = this.qryData['sorts']
                this.pageInfo.details = this.qryData['details']
                this.pageInfo.startDate = this.qryData['startDate']
                this.pageInfo.endDate = this.qryData['endDate']
                this.pageInfo.billTypes = this.qryData['billTypes']
                this.pageInfo.billStatus = this.qryData['billStatus']

                if (this.refreshing) {
                    this.list = [];
                    this.pageInfo.current = 1
                    this.pageInfo.total=-1
                    this.refreshing = false
                }

                let ths = this
                if(this.list.length == this.pageInfo.total){
                    this.finished = true;
                    return false
                }
                let params = this.pageInfo
                this.$axios.post(MyApi.QRY_FIN_LIST,params/*,options*/)
                    .then((response) =>  {
                        let code = response.code;
                        if(code == '200'){

                            let data = response.data
                            if(data.records.length >0){
                                ths.pageInfo.current ++

                                //ths.list = data.records
                                ths.list = ths.list.concat(data.records)
                                ths.pageInfo.total = data.total;
                                if(ths.list.length == data.records.total){
                                    this.finished = true;
                                }

                            }else{
                                this.finished = true;
                            }
                        }
                        this.loading = false;

                    })
                    .catch((err) =>{
                        this.loading = false
                        this.error = true
                        this.$toast.fail("数据初始化异常"+err);
                    })

            },
            splitDate(inputDate) {
                return inputDate.substr(0,10)
            },
            splitTime(inputDate) {
                return inputDate.substr(11,5)
            },
            getFinType(finType){
                if(finType == '12101'){
                    return "danger"
                }else{
                    return  "primary"
                }
                //return finTypeName
            },
            onClickLeft() {
                history.back();
            },
            getParams(){
                this.pageInfo.month = this.$route.params.month;
                this.pageInfo.day = this.$route.params.day;
                this.pageInfo.finType = this.$route.params.finType;
                this.pageInfo.sortDetail = this.$route.params.sortDetail;
            },
            onRefresh() {
                // 清空列表数据
                this.finished = false;
                this.refreshing = true;

                // 重新加载数据
                // 将 loading 设置为 true，表示处于加载状态
                this.loading = true;
                this.onLoad();
            },
            alterFin(finId){
                let month = this.pageInfo.month
                this.$router.push({ name:'finance',params:{finId:finId,month:month} })
            },
            removeFin(finId){
                this.$dialog.confirm({
                    title: '删除',
                    message: '确认删除该数据吗？'
                }).then(() => {
                    let params = {"finId":finId}
                    this.$axios.post(MyApi.FINANCE_DEL_URL,params/*,options*/)
                        .then((response) =>  {
                            let code = response.code;
                            if(code == '200'){
                                this.$toast.success(response.msg);
                                // 清空列表数据
                                this.finished = false;
                                this.refreshing = true;
                                // 重新加载数据
                                // 将 loading 设置为 true，表示处于加载状态
                                this.loading = true;
                                this.onLoad();
                            }
                        })
                        .catch((err) =>{
                            this.$toast.fail("删除异常"+err);
                        })

                }).catch(() => {

                });
            },
            showPopup() {
                this.popupShow = true;
            },
            getQryData(qryData) {

                this.popupShow = qryData.popupShow;
                this.pageInfo.belongs = qryData.belongs;
                this.pageInfo.startDate = qryData.startDate;
                this.pageInfo.endDate = qryData.endDate;
                this.pageInfo.sorts = qryData.sorts;
                this.pageInfo.payers = qryData.payers;
                this.pageInfo.finTypes = qryData.finTypes;
                this.pageInfo.details = qryData.details;
                this.onRefresh();

            }
        }

    }


</script>

<style scoped="scoped">
    .upd-button {
        height: 100%;
    }
    .van-list >>> .van-list__finished-text{
        margin-bottom: 50px;
    }


</style>
